
import ContactForm from "@/components/contact/ContactForm";
import NewsletterSignup from "@/components/contact/NewsletterSignup";
import ContactInfo from "@/components/contact/ContactInfo";
import SocialMediaCard from "@/components/contact/SocialMediaCard";
import FAQSection from "@/components/contact/FAQSection";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const Contact = () => {
  return (
    <>
      <Navbar />
      <div className="min-h-screen">
        {/* Header */}
        <section className="w-full bg-gradient-to-r from-bobo-green to-teedee-blue text-white">
          <div className="w-full py-20 lg:py-24">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
              <h1 className="text-5xl lg:text-6xl font-bold mb-8">
                Connect with Bobo & Teedee®
              </h1>
              <p className="text-xl lg:text-2xl max-w-4xl mx-auto opacity-90 leading-relaxed">
                We'd love to hear from you! Get in touch, subscribe to our newsletter, or follow us on social media for the latest updates.
              </p>
            </div>
          </div>
        </section>

        
        <div className="bg-gradient-to-br from-sky-blue/20 via-white to-bobo-green/20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
              {/* Contact Form */}
              <ContactForm />

              {/* Contact Info & Newsletter */}
              <div className="space-y-10">
                {/* Newsletter Signup */}
                <NewsletterSignup />

                {/* Contact Information */}
                <ContactInfo />

                {/* Social Media */}
                <SocialMediaCard />
              </div>
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <FAQSection />
      </div>
      <Footer />
    </>
  );
};

export default Contact;
